// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Z5Z_","header":"ClearentDisclaimer_header__1t9gJ","inner":"ClearentDisclaimer_inner__lZvzF"};